import { render, staticRenderFns } from "./LangNav.vue?vue&type=template&id=7e8d8220"
import script from "./LangNav.vue?vue&type=script&lang=js"
export * from "./LangNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports